import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DashboardData as DashboardStats } from '@redpanda/types';
import { getDashboardStats } from '../services/api';

interface DashboardState {
  stats: DashboardStats | null;
  error: string | null;
  lastFetchTime: number | null;
  fetchDashboardStats: (forceRefresh?: boolean) => Promise<void>;
}


export const useDashboardStore = create<DashboardState>()(
  persist(
    (set, get) => ({
      stats: null,
      error: null,
      lastFetchTime: null,
      fetchDashboardStats: async (forceRefresh = false) => {
        const state = get();
        
        // 強制刷新時直接獲取，不使用背景檢查機制
        if (forceRefresh) {
          set({ error: null });
          try {
            const response = await getDashboardStats();
            set({ 
              stats: response.data,
              lastFetchTime: Date.now()
            });
          } catch (err: any) {
            const errorMessage = err.message || 'An unknown error occurred';
            set({ error: errorMessage });
          }
          return;
        }
        
        // 檢查快取是否有效（永久有效）
        if (state.stats && state.lastFetchTime) {
          return;
        }
        
        set({ error: null });
        try {
          const response = await getDashboardStats();
          set({ 
            stats: response.data,
            lastFetchTime: Date.now()
          });
        } catch (err: any) {
          const errorMessage = err.message || 'An unknown error occurred';
          set({ error: errorMessage });
        }
      },
    }),
    {
      name: 'dashboard-storage',
      partialize: (state) => ({
        stats: state.stats,
        lastFetchTime: state.lastFetchTime,
      }),
    }
  )
);
